import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {userActions, hairdresserActions} from "../../_actions";
import {userService} from "../../_services/user.service";
import toast from '../shared/Toast';
import PhoneInput from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import '../Dashboard/Myaccount.css';
import siteSetting from '../../config/env';
import { clearAllConciergeSessions } from '../../_services/conciergeSessionStore';

class DashboardAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CreateEditPopup: false,
            errors: {},
            newconfirmPassword: '',
            oldPassword: '',
            newPassword: '',
            ChangepasswordPopup: false,
            userInfo: props.user,
            first_name:'',
            last_name:'',
            email:'',
            image:'',
            imagePreview: props.user ? (props.user.avatar && props.user.avatar != '') ? props.user.avatar :  require('../../assets/images/Pixie.png') : require('../../assets/images/Pixie.png'),
            passwordError: '',
            emailError: '',
            fNameError: '',
            lNameError: '',
            phoneNumber:'',
            isEditing: false,
            isChangingPassword: false,
            firstPasswordMode: false,
            isSwitchingToBusiness: false,
            showProfileEdit: false,
            // Stats
            totalBookings: 0,
            totalReviews: 0,
            memberSince: new Date().getFullYear(),
            loadingStats: true
        }
        this.toggleEditPopup = this.toggleEditPopup.bind(this);
        this.deleteProfile = this.deleteProfile.bind(this)
        this.toggleChangepasswordPopup = this.toggleChangepasswordPopup.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.editProfile=this.editProfile.bind(this);
        this.onChanged = this.onChanged.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.getInitials = this.getInitials.bind(this);
        this.hasValidAvatar = this.hasValidAvatar.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    getInitials(name) {
        if (!name) return 'U';
        // Check if name looks like a MongoDB ObjectId (24 hex characters)
        if (typeof name === 'string' && /^[a-f0-9]{24}$/i.test(name)) {
            return 'U';
        }
        return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }

    hasValidAvatar() {
        const { userInfo } = this.state;
        return userInfo && userInfo.avatar && userInfo.avatar !== '' &&
               !userInfo.avatar.includes('Pixie.png') &&
               !userInfo.avatar.includes('user-placeholder.png');
    }

    componentDidMount() {
        // Fetch client profile with stats from new v2 API (single call)
        this.fetchClientProfile();
        // Claim landing (magic link, spec §5) sends ?setup=password — the
        // account has NO password yet, so open the form in first-password
        // mode (no "current password" field; posts to /v2/user/setFirstPassword).
        if ((this.props.location?.search || '').includes('setup=password')) {
            this.setState({ isChangingPassword: true, showProfileEdit: true, firstPasswordMode: true });
        }
    }

    fetchClientProfile = async () => {
        const { dispatch } = this.props;
        this.setState({ loadingStats: true });
        
        try {
            // Single API call to get user info + stats (replaces old v1 profile + multiple booking/review calls)
            const response = await dispatch(userActions.clientProfile());
            const profileData = response?.data?.responseData;
            
            if (profileData) {
                const { userInfo, stats } = profileData;
                
                this.setState({
                    userInfo: userInfo,
                    first_name: userInfo.first_name || userInfo.name || '',
                    last_name: userInfo.last_name || '',
                    email: userInfo.email || '',
                    phoneNumber: userInfo.phoneNumber && userInfo.phoneNumber !== "" ? this.getPhoneNumber(userInfo.phoneNumber) : "",
                    imagePreview: userInfo.avatar && userInfo.avatar !== '' ? userInfo.avatar : require('../../assets/images/Pixie.png'),
                    totalBookings: stats?.totalBookings || 0,
                    totalReviews: stats?.totalReviews || 0,
                    memberSince: stats?.memberSince || new Date().getFullYear(),
                    loadingStats: false
                });
            } else {
                this.setState({ loadingStats: false });
            }
        } catch (error) {
            console.error('Error fetching client profile:', error);
            this.setState({ loadingStats: false });
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        let {user} = props;
        let self=this;
        if(user) {
            this.setState({
                userInfo: user,
                first_name: user.first_name ? user.first_name : user.name,
                last_name: user.last_name,
                email: user.email,
                phoneNumber:user.phoneNumber&&user.phoneNumber!=""?self.getPhoneNumber(user.phoneNumber):"",
                imagePreview: user ? (user.avatar && user.avatar != '') ? user.avatar :  require('../../assets/images/Pixie.png') : require('../../assets/images/Pixie.png'),
                image: '',
            })
        }
    }

    getPhoneNumber=(phoneNumber)=>{
        let phone=phoneNumber.toString()
        if(phone.length===10){
            if (phone[0] === 0||phone[0] === "0") {
                return "+44"+phone.substr(1)
            }else{
                return "+44"+phone
            }
        }else {
            if (phone[0] === 0||phone[0] === "0") {
                return "+44"+phone.substr(1)
            } else if (phone[0] === 4||phone[0] === "4") {
                return "+" + phone
            } else {
                return "+44"+phone
            }
        }
    }

    handlePasswordChange(event) {
        if (event.target.id == 'oldPassword') {
            this.setState({oldPassword: event.target.value})
        }
        if (event.target.id == 'newPassword') {
            this.setState({newPassword: event.target.value})
        }
        if (event.target.id == 'newconfirmPassword') {
            this.setState({newconfirmPassword: event.target.value})
        }
    }

    changePassword() {
        var self = this

        if (this.handleValidation()) {
            if (self.state.newPassword != self.state.newconfirmPassword) {
                toast.error('Password did not match');
            } else if (self.state.firstPasswordMode) {
                // Claim flow: no old password exists — v2 setFirstPassword
                // (refuses server-side if a password is already set).
                userService.setFirstPassword({ newPassword: self.state.newPassword })
                    .then(function (response) {
                        if (response?.data?.statusCode === 0) {
                            toast.error(response?.data?.error?.responseMessage || 'Could not set password');
                            return;
                        }
                        toast.success('Password set. You can now log in with it');
                        self.setState({
                            isChangingPassword: false,
                            showProfileEdit: false,
                            firstPasswordMode: false,
                            oldPassword: '', newPassword: '', newconfirmPassword: '',
                            errors: {}
                        });
                    })
                    .catch(function () { toast.error('Could not set password'); });
            } else {
                let {newPassword, oldPassword} = self.state
                let params = {
                    newPassword: newPassword,
                    oldPassword: oldPassword,
                }
                self.props.dispatch(userActions.changePassword(params))
                    .then(function (response) {
                        if (response.data.errorCode === 0) {
                            toast.success('Password changed successfully');
                            self.setState({
                                isChangingPassword: false,
                                oldPassword: '',
                                newPassword: '',
                                newconfirmPassword: '',
                                errors: {}
                            })
                        } else {
                            toast.error(response.data.messages);
                        }
                    })
            }

        }
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;
        var self = this;
        if (!self.state.newPassword) {
            formIsValid = false;
            errors["newPassword"] = "New password can not be empty";
        }
        if (!self.state.oldPassword && !self.state.firstPasswordMode) {
            formIsValid = false;
            errors["oldPassword"] = "Old password can not be empty";
        }
        if (!self.state.newconfirmPassword) {
            formIsValid = false;
            errors["newconfirmPassword"] = "Confirm password can not be empty";
        }

        self.setState({errors: errors});
        return formIsValid;
    }

    toggleEditPopup(value) {
        if (value === 1) {
            // Entering edit mode
            this.setState({ isEditing: true, showProfileEdit: true });
        } else {
            // Canceling edit mode
            this.setState({
                isEditing: false,
                showProfileEdit: false,
                fNameError: '',
                lNameError: '',
                emailError: '',
                phoneNumberError: ''
            });
        }
    }

    deleteProfile() {
        window.open('mailto:info@beuapp.com?subject=Request Account Deletion');
    }

    toggleChangepasswordPopup(value) {
        if (value === 1) {
            this.setState({ isChangingPassword: true, showProfileEdit: true });
        } else {
            this.setState({
                isChangingPassword: false,
                showProfileEdit: false,
                oldPassword: '',
                newPassword: '',
                newconfirmPassword: '',
                errors: {}
            });
        }
    }

    editProfile(){
        let self = this;
        let email = this.state.email;
        let first_name = this.state.first_name;
        let last_name = this.state.last_name;
        let phoneNumber = this.state.phoneNumber;
        
        // Validation
        if (this.state.first_name === "" || this.state.first_name === undefined) {
            this.setState({
                fNameError: 'Please enter first name'
            })
            return;
        } else if (this.state.last_name === "" || this.state.last_name === undefined) {
            this.setState({
                lNameError: 'Please enter last name'
            })
            return;
        } else if (this.state.email === "" || this.state.email === undefined) {
            this.setState({
                emailError: "Please enter your email address"
            })
            return;
        } else if (!this.validateEmail(this.state.email)) {
            this.setState({
                emailError: 'Please enter a valid email address'
            })
            return;
        } else if (this.state.phoneNumber === "" || this.state.phoneNumber === undefined) {
            this.setState({
                phoneNumberError: 'Please enter a valid phone number'
            })
            return;
        }

        // Use new client edit API that updates globally across all salons
        let clientEditParams = {
            clientId: localStorage.getItem('userId'),
            first_name: first_name,
            last_name: last_name,
            name: first_name + " " + last_name,
            email: email,
            phoneNumber: phoneNumber
        };

        self.props.dispatch(userActions.editClientProfile(clientEditParams))
            .then(function (response) {
                // API returns statusCode: 1 for success
                if (response.data.statusCode === 1) {
                    // Refresh profile using new v2 API
                    self.fetchClientProfile();
                    self.setState({ isEditing: false, showProfileEdit: false });
                    toast.success('Profile updated successfully');
                } else {
                    self.setState({
                        error: response.data.responseData?.message || 'Failed to update profile'
                    });
                    toast.error(response.data.responseData?.message || 'Failed to update profile');
                }
            })
            .catch(function (error) {
                toast.error('Failed to update profile');
            });
    }

    validateEmail(email) {
        const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const result = pattern.test(email);
        return result;
    }

    onChanged(e) {
        this.setState({[e.target.name]: e.target.value, copied: false});

        if (e.target.name == 'userImage') {
            let reader = new FileReader();
            let file = e.target.files[0];

            reader.onloadend = () => {
                this.setState({
                    imagePreview: reader.result
                });
            }
            reader.readAsDataURL(file)


            this.setState({
                imagePreview: file
            })
            this.setState({
                image: e.target.files[0]
            });
        }

        if (e.target.name === 'email') {
            if (!this.validateEmail(e.target.value)) {
                this.setState({
                    emailError: 'Please enter a valid email address'
                })
            } else {
                this.setState({
                    emailError: ''
                })
            }
        }
        if (e.target.name === 'password') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    passwordError: ''
                })
            } else {
                this.setState({
                    passwordError: '',
                })
            }
        }

        if (e.target.name === 'first_name') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    fNameError: ''
                })
            } else {
                this.setState({
                    fNameError: '',
                })
            }
        }

        if (e.target.name === 'last_name') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    fNameError: ''
                })
            } else {
                this.setState({
                    lNameError: '',
                })
            }
        }
    }

    handlePhoneChange = val => {
        this.setState({phoneNumber: val})
    }

    // Check if user is a hairdresser
    isHairdresser = () => {
        const { userInfo } = this.state;
        // Primary check: userInfo.hairdresser
        if (userInfo?.hairdresser) {
            return true;
        }
        // Fallback: check if salonId exists in localStorage
        const salonId = localStorage.getItem('salonId');
        if (salonId && salonId !== '' && salonId !== 'null' && salonId !== 'undefined') {
            return true;
        }
        return false;
    }

    // Check if user is an admin
    isAdmin = () => {
        const { userInfo } = this.state;
        return userInfo?.isAdmin === true;
    }

    // Handle switch to admin panel
    handleSwitchToAdmin = (e) => {
        e.preventDefault();
        this.props.history.push('/beu-admin-x7k9/dashboard');
    }

    // Handle go to sales dashboard
    handleGoToSales = (e) => {
        e.preventDefault();
        this.props.history.push('/sales-x7k9');
    }

    // Handle switch to business profile - same logic as DashboardSidebar
    handleSwitchToBusiness = (e) => {
        e.preventDefault();
        
        if (this.state.isSwitchingToBusiness) return;
        this.setState({ isSwitchingToBusiness: true });

        const param = {
            latitude: siteSetting.default_latitude,
            longitude: siteSetting.default_longitude,
            switchTo: 1
        };

        this.props.dispatch(hairdresserActions.hairdresserSwitchProfile(param))
            .then((response) => {
                if (response.data.data.userInfo && response.data.data.userInfo.hairdresser && response.data.data.userInfo.hairdresser.salon) {
                    const salonId = response.data.data.userInfo.hairdresser.salon._id;
                    localStorage.setItem('salonId', salonId);
                    localStorage.setItem('defaultRedirectTo', response.data.data.userInfo.defaultRedirectTo);
                    localStorage.setItem('isShow', response.data.data.userInfo.hairdresser.salon.isShow);

                    // Check if reception mode is enabled and diary is hidden
                    const cachedSettings = localStorage.getItem('receptionModeSettings');
                    if (cachedSettings) {
                        const { enabled, hiddenAreas } = JSON.parse(cachedSettings);
                        if (enabled && hiddenAreas && hiddenAreas.diary) {
                            // If diary is hidden, redirect to settings/reception-mode
                            this.props.history.push('/settings/reception-mode');
                            this.setState({ isSwitchingToBusiness: false });
                            return;
                        }
                    }

                    // Otherwise, redirect to diary as usual
                    this.props.history.push('/diary/' + salonId);
                } else {
                    console.error('No salon found for hairdresser');
                }
                this.setState({ isSwitchingToBusiness: false });
            })
            .catch((err) => {
                console.error('Error switching to business:', err);
                this.setState({ isSwitchingToBusiness: false });
            });
    }

    handleLogout(e) {
        e.preventDefault();
        // Clear all authentication data from localStorage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('salonId');
        localStorage.removeItem('defaultRedirectTo');
        localStorage.removeItem('isShow');
        localStorage.removeItem('receptionModeSettings');
        // And the booking page's chat (sessionStorage), so the next person
        // on this device doesn't inherit it.
        clearAllConciergeSessions();
        
        // Redirect to home page
        this.props.history.push('/');
    }

    // Get member since year (now from state, populated by v2 API)
    getMemberSince = () => {
        return this.state.memberSince;
    }

    // Get user's location
    getUserLocation = () => {
        const { userInfo } = this.state;
        // Handle country being either a string (country name), an object with englishName, or a MongoDB ObjectId
        const getCountryName = (country) => {
            if (!country) return null;
            // Check if it's a MongoDB ObjectId (24 hex characters) - don't display these
            if (typeof country === 'string' && /^[a-f0-9]{24}$/i.test(country)) {
                return null;
            }
            if (typeof country === 'string') return country;
            if (typeof country === 'object' && country.englishName) return country.englishName;
            return null;
        };
        const countryName = getCountryName(userInfo?.country);
        
        if (userInfo?.city && countryName) {
            return `${userInfo.city}, ${countryName}`;
        } else if (userInfo?.city) {
            return userInfo.city;
        } else if (countryName) {
            return countryName;
        }
        return 'United Kingdom';
    }

    // Get full name - ensure we never show an ID
    getFullName = () => {
        const { userInfo } = this.state;
        if (userInfo?.first_name && userInfo?.last_name) {
            return `${userInfo.first_name} ${userInfo.last_name}`;
        } else if (userInfo?.first_name) {
            return userInfo.first_name;
        } else if (userInfo?.name) {
            // Check if name looks like a MongoDB ObjectId (24 hex characters)
            const name = userInfo.name;
            if (name && typeof name === 'string' && /^[a-f0-9]{24}$/i.test(name)) {
                return 'User';
            }
            return name;
        }
        return 'User';
    }

    // Render skeleton loader while data is loading
    renderSkeleton() {
        return (
            <div className="dashboard-fade-in profile-page-container">
                {/* Page Title Skeleton */}
                <div className="skeleton-page-title"></div>

                {/* Profile Card Skeleton */}
                <div className="profile-main-card skeleton-card">
                    <div className="profile-card-content">
                        {/* Left side - Avatar and info skeleton */}
                        <div className="profile-card-left">
                            <div className="profile-avatar-section">
                                <div className="profile-avatar-wrapper">
                                    <div className="skeleton-avatar"></div>
                                </div>
                            </div>
                            <div className="profile-name-section">
                                <div className="skeleton-name"></div>
                                <div className="skeleton-location"></div>
                            </div>
                        </div>

                        {/* Right side - Stats skeleton */}
                        <div className="profile-card-right">
                            <div className="profile-stat">
                                <div className="skeleton-stat-number"></div>
                                <div className="skeleton-stat-label"></div>
                            </div>
                            <div className="profile-stat-divider"></div>
                            <div className="profile-stat">
                                <div className="skeleton-stat-number"></div>
                                <div className="skeleton-stat-label"></div>
                            </div>
                            <div className="profile-stat-divider"></div>
                            <div className="profile-stat">
                                <div className="skeleton-stat-number"></div>
                                <div className="skeleton-stat-label"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Business Card Skeleton */}
                <div className="skeleton-business-card">
                    <div className="skeleton-business-icon"></div>
                    <div className="skeleton-business-content">
                        <div className="skeleton-business-title"></div>
                        <div className="skeleton-business-text"></div>
                    </div>
                </div>

                {/* Settings Section Skeleton */}
                <div className="skeleton-settings-section">
                    <div className="skeleton-settings-item">
                        <div className="skeleton-settings-icon"></div>
                        <div className="skeleton-settings-label"></div>
                    </div>
                    <div className="skeleton-settings-item">
                        <div className="skeleton-settings-icon"></div>
                        <div className="skeleton-settings-label"></div>
                    </div>
                    <div className="skeleton-settings-item">
                        <div className="skeleton-settings-icon"></div>
                        <div className="skeleton-settings-label"></div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { showProfileEdit, isEditing, isChangingPassword, loadingStats } = this.state;

        // Show skeleton loader while data is loading
        if (loadingStats) {
            return (
                <React.Fragment>
                    {this.renderSkeleton()}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <div className="dashboard-fade-in profile-page-container">

                    {/* Page Title */}
                    <h1 className="profile-page-title">Profile</h1>

                    {/* Profile Card - Clickable to edit */}
                    <div
                        className="profile-main-card"
                        onClick={() => !showProfileEdit && this.toggleEditPopup(1)}
                    >
                        <div className="profile-card-content">
                            {/* Left side - Avatar and info */}
                            <div className="profile-card-left">
                                <div className="profile-avatar-section">
                                    <div className="profile-avatar-wrapper">
                                        {this.hasValidAvatar() ? (
                                            <img
                                                src={this.state.imagePreview}
                                                alt="Profile"
                                                className="profile-avatar-img"
                                            />
                                        ) : (
                                            <div className="profile-avatar-initials">
                                                {this.getInitials(this.getFullName())}
                                            </div>
                                        )}
                                        {/* Edit pencil icon */}
                                        <div className="profile-edit-badge">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="profile-name-section">
                                    <h2 className="profile-name">{this.getFullName()}</h2>
                                    <p className="profile-location">{this.getUserLocation()}</p>
                                </div>
                            </div>

                            {/* Right side - Stats */}
                            <div className="profile-card-right">
                                <div className="profile-stat">
                                    <span className="profile-stat-number">{this.state.totalBookings}</span>
                                    <span className="profile-stat-label">Bookings</span>
                                </div>
                                <div className="profile-stat-divider"></div>
                                <div className="profile-stat">
                                    <span className="profile-stat-number">{this.state.totalReviews}</span>
                                    <span className="profile-stat-label">Reviews</span>
                                </div>
                                <div className="profile-stat-divider"></div>
                                <div className="profile-stat">
                                    <span className="profile-stat-number">{this.getMemberSince()}</span>
                                    <span className="profile-stat-label">Member since</span>
                                </div>
                            </div>
                        </div>

                        {/* Hidden file input for photo upload */}
                        <input
                            ref={(ref) => this.userImage = ref}
                            type="file"
                            name="userImage"
                            onChange={this.onChanged}
                            id="userImage"
                            style={{display: 'none'}}
                        />
                    </div>

                    {/* Profile Edit Modal/Section */}
                    {showProfileEdit && (
                        <div className="profile-edit-section">
                            <div className="profile-edit-card">
                                <div className="profile-edit-header">
                                    <h3>{isChangingPassword ? (this.state.firstPasswordMode ? 'Set Password' : 'Change Password') : 'Edit Profile'}</h3>
                                    <button 
                                        className="profile-edit-close"
                                        onClick={() => isChangingPassword ? this.toggleChangepasswordPopup(2) : this.toggleEditPopup(2)}
                                    >
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                        </svg>
                                    </button>
                                </div>

                                {isEditing && !isChangingPassword ? (
                                    // Edit Profile Form
                                    <div className="profile-edit-form">
                                        <div className="profile-form-group">
                                            <label>First Name</label>
                                            <input
                                                type="text"
                                                placeholder="First Name"
                                                name="first_name"
                                                autoComplete="off"
                                                value={this.state.first_name}
                                                onChange={this.onChanged}
                                            />
                                            {this.state.fNameError && (
                                                <span className="profile-error">{this.state.fNameError}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-group">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                placeholder="Last Name"
                                                name="last_name"
                                                autoComplete="off"
                                                value={this.state.last_name}
                                                onChange={this.onChanged}
                                            />
                                            {this.state.lNameError && (
                                                <span className="profile-error">{this.state.lNameError}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-group">
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                placeholder="Email"
                                                name="email"
                                                value={this.state.email}
                                                onChange={this.onChanged}
                                            />
                                            {this.state.emailError && (
                                                <span className="profile-error">{this.state.emailError}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-group">
                                            <label>Mobile</label>
                                            <PhoneInput
                                                international={true}
                                                defaultCountry="GB"
                                                country={"GB"}
                                                className="profile-phone-input"
                                                placeholder="Enter phone number"
                                                name="phoneNumber"
                                                value={this.state.phoneNumber}
                                                onChange={this.handlePhoneChange}
                                            />
                                            {this.state.phoneNumberError && (
                                                <span className="profile-error">{this.state.phoneNumberError}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-group">
                                            <label>Password</label>
                                            <div className="profile-password-row">
                                                <span>••••••••</span>
                                                <button 
                                                    type="button"
                                                    className="profile-change-password-btn"
                                                    onClick={() => {
                                                        this.setState({ isEditing: false, isChangingPassword: true });
                                                    }}
                                                >
                                                    Change
                                                </button>
                                            </div>
                                        </div>

                                        <div className="profile-form-actions">
                                            <button
                                                className="profile-btn profile-btn-primary"
                                                onClick={this.editProfile}
                                            >
                                                Save Changes
                                            </button>
                                            <button
                                                className="profile-btn profile-btn-secondary"
                                                onClick={() => this.toggleEditPopup(2)}
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                        <div className="profile-delete-section">
                                            <button
                                                className="profile-delete-btn"
                                                onClick={this.deleteProfile}
                                            >
                                                Delete Account
                                            </button>
                                        </div>
                                    </div>
                                ) : isChangingPassword ? (
                                    // Change Password Form
                                    <div className="profile-edit-form">
                                        {this.state.error && (
                                            <div className="profile-error-banner">{this.state.error}</div>
                                        )}

                                        {!this.state.firstPasswordMode && (
                                        <div className="profile-form-group">
                                            <label>Current Password</label>
                                            <input
                                                type="password"
                                                name="oldPassword"
                                                placeholder="Enter current password"
                                                id="oldPassword"
                                                value={this.state.oldPassword}
                                                onChange={this.handlePasswordChange}
                                                autoComplete="off"
                                            />
                                            {this.state.errors["oldPassword"] && (
                                                <span className="profile-error">{this.state.errors["oldPassword"]}</span>
                                            )}
                                        </div>
                                        )}

                                        <div className="profile-form-group">
                                            <label>New Password</label>
                                            <input
                                                type="password"
                                                name="newPassword"
                                                id="newPassword"
                                                placeholder="Enter new password"
                                                value={this.state.newPassword}
                                                onChange={this.handlePasswordChange}
                                                autoComplete="off"
                                            />
                                            {this.state.errors["newPassword"] && (
                                                <span className="profile-error">{this.state.errors["newPassword"]}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-group">
                                            <label>Confirm New Password</label>
                                            <input
                                                type="password"
                                                name="newconfirmPassword"
                                                id="newconfirmPassword"
                                                placeholder="Confirm new password"
                                                value={this.state.newconfirmPassword}
                                                onChange={this.handlePasswordChange}
                                                autoComplete="off"
                                            />
                                            {this.state.errors["newconfirmPassword"] && (
                                                <span className="profile-error">{this.state.errors["newconfirmPassword"]}</span>
                                            )}
                                        </div>

                                        <div className="profile-form-actions">
                                            <button
                                                className="profile-btn profile-btn-primary"
                                                onClick={this.changePassword}
                                            >
                                                {this.state.firstPasswordMode ? 'Set Password' : 'Change Password'}
                                            </button>
                                            <button
                                                className="profile-btn profile-btn-secondary"
                                                onClick={() => this.toggleChangepasswordPopup(2)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    )}

                    {/* Switch to Business Card - for existing business owners */}
                    {this.isHairdresser() && (
                        <a
                            href="#"
                            className={`become-business-card ${this.state.isSwitchingToBusiness ? 'is-switching' : ''}`}
                            onClick={this.handleSwitchToBusiness}
                        >
                            <div className="become-business-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="48" height="48">
                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                    <line x1="8" y1="21" x2="16" y2="21" />
                                    <line x1="12" y1="17" x2="12" y2="21" />
                                </svg>
                            </div>
                            <div className="become-business-content">
                                {/* Label stays constant during the switch so the flex h3
                                    doesn't shrink visibly when "Switch to business"
                                    swaps to "Switching..."; loading feedback comes
                                    from the .is-switching class (opacity 0.7). Not
                                    .loading: a global .loading rule in index.css
                                    forces width 31% !important and crushed the card. */}
                                <h3>Switch to business</h3>
                                <p>Manage your business and appointments.</p>
                            </div>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="become-business-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </a>
                    )}

                    {/* Switch to Admin Card - for admin users only */}
                    {this.isAdmin() && (
                        <a
                            href="#"
                            className="become-business-card admin-card"
                            onClick={this.handleSwitchToAdmin}
                        >
                            <div className="become-business-icon admin-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="48" height="48">
                                    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" />
                                </svg>
                            </div>
                            <div className="become-business-content">
                                <h3>Switch to admin</h3>
                                <p>Access admin panel to manage all users, professionals, and businesses.</p>
                            </div>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="become-business-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </a>
                    )}

                    {/* Go to Sales Dashboard Card - admin gated until the sales role exists */}
                    {this.isAdmin() && (
                        <a
                            href="#"
                            className="become-business-card admin-card"
                            onClick={this.handleGoToSales}
                        >
                            <div className="become-business-icon admin-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="48" height="48">
                                    <path d="M3 3v18h18" />
                                    <path d="M7 14l4-4 3 3 6-6" />
                                    <path d="M20 7h-4m4 0v4" />
                                </svg>
                            </div>
                            <div className="become-business-content">
                                <h3>Go to sales dashboard</h3>
                                <p>Work the salon pipeline, call queue and sales map.</p>
                            </div>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="become-business-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </a>
                    )}

                    {/* Settings Section */}
                    <div className="profile-settings-section">
                        <Link to="/dashboard/wallet" className="profile-settings-item">
                            <div className="profile-settings-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                                    <rect x="3" y="8" width="18" height="13" rx="1.5" />
                                    <path d="M3 12h18M12 8v13" />
                                    <path d="M12 8S10.5 3.5 8 4.2C6.2 4.7 6.5 7.5 9 8M12 8s1.5-4.5 4-3.8c1.8.5 1.5 3.3-1 3.8" />
                                </svg>
                            </div>
                            <span className="profile-settings-label">Wallet</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </Link>

                        <Link to="/dashboard/loyalty" className="profile-settings-item">
                            <div className="profile-settings-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                                    <circle cx="9" cy="9" r="4" />
                                    <circle cx="16" cy="15.5" r="3.4" strokeDasharray="2.4 2.6" />
                                    <path d="M14.4 5.6 18.4 9.6M18.4 5.6l-4 4" />
                                </svg>
                            </div>
                            <span className="profile-settings-label">Loyalty</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </Link>

                        <Link to="/dashboard/reviews" className="profile-settings-item">
                            <div className="profile-settings-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                            </div>
                            <span className="profile-settings-label">Reviews</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </Link>

                        <Link to="/dashboard/marketing-preferences" className="profile-settings-item">
                            <div className="profile-settings-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
                                    <path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" />
                                    <polyline points="21,7 12,13 3,7" />
                                </svg>
                            </div>
                            <span className="profile-settings-label">Marketing preferences</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </Link>

                        <a href="mailto:info@beuapp.com?subject=Help%20%26%20Support" className="profile-settings-item">
                            <div className="profile-settings-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                                </svg>
                            </div>
                            <span className="profile-settings-label">Help & Support</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </a>

                        <a
                            href="#"
                            className="profile-settings-item profile-logout-item"
                            onClick={this.handleLogout}
                        >
                            <div className="profile-settings-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    <polyline points="16 17 21 12 16 7" />
                                    <line x1="21" y1="12" x2="9" y2="12" />
                                </svg>
                            </div>
                            <span className="profile-settings-label">Log Out</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" className="profile-settings-arrow">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


function mapStateToProps(state) {
  // User data is in state.user.userInfo for client dashboard
  const { user: userReducer } = state;
  const user = userReducer?.userInfo || null;
  
  return {
    user
  };
}

export default withRouter(connect(mapStateToProps)(DashboardAccount));